module.exports = __webpack_public_path__ + "media/images/pla/pla12-4da704a803cef747a12ff8c6b692f485.jpg";